const cards = [
  {
    title: '豆瓣8.5+高分电影推荐',
    desc: '精选豆瓣评分8.5以上的口碑佳作，涵盖剧情、科幻、动画等多种类型，每一部都值得反复观看。从经典老片到当代新作，这个片单是你的观影品质保证。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20film%20award%20ceremony%20atmosphere%20with%20golden%20statue%20and%20warm%20spotlight%2C%20cinematic%20prestige%20aesthetic%2C%20dark%20background%20with%20amber%20and%20coral%20accents%2C%20professional%20movie%20poster%20composition%2C%20soft%20dramatic%20lighting&width=600&height=400&seq=cards-01&orientation=landscape',
    tag: '高分推荐',
  },
  {
    title: '周末宅家必看片单',
    desc: '为你准备了一份完美的周末观影计划：从轻松喜剧到深度剧情，从热血动作到治愈动画，搭配零食和好心情。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20cinema%20setup%20with%20warm%20ambient%20lighting%2C%20soft%20blankets%20and%20popcorn%2C%20movie%20projection%20glow%2C%20comfortable%20living%20room%20aesthetic%2C%20warm%20golden%20and%20coral%20tones%2C%20cinematic%20evening%20atmosphere&width=600&height=400&seq=cards-02&orientation=landscape',
    tag: '周末精选',
  },
  {
    title: '冷门高分：被埋没的宝石',
    desc: '这些电影可能没有华丽宣发，但凭借出色的剧本和表演赢得口碑。发掘那些藏在角落里的冷门高分佳作。',
    img: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20discovery%20concept%20with%20vintage%20film%20elements%2C%20old%20movie%20posters%20and%20warm%20lighting%2C%20treasure%20hunting%20aesthetic%2C%20nostalgic%20cinema%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20soft%20dramatic%20composition&width=600&height=400&seq=cards-03&orientation=landscape',
    tag: '冷门佳片',
  },
  {
    title: '女性视角：她故事她力量',
    desc: '聚焦女性导演作品与女性叙事电影，从《伯德小姐》到《小妇人》，看见多元的女性故事与细腻情感表达。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20feminine%20cinema%20aesthetic%20with%20soft%20warm%20lighting%2C%20elegant%20composition%20with%20flowers%20and%20film%20elements%2C%20pastel%20coral%20and%20golden%20tones%2C%20empowering%20atmosphere%2C%20cinematic%20portrait%20style%20with%20dark%20subtle%20background&width=600&height=400&seq=cards-04&orientation=landscape',
    tag: '女性力量',
  },
  {
    title: '烧脑神作：看完怀疑人生',
    desc: '这些电影用精妙叙事挑战观众的认知边界。非线性叙事、多重反转、开放式结局，每一部都值得二刷。',
    img: 'https://readdy.ai/api/search-image?query=Mind-bending%20abstract%20geometric%20composition%20with%20spiral%20and%20maze%20elements%2C%20warm%20amber%20and%20coral%20light%20streaks%2C%20psychological%20thriller%20aesthetic%2C%20dark%20background%20with%20dramatic%20highlights%2C%20cinematic%20puzzle%20visual&width=600&height=400&seq=cards-05&orientation=landscape',
    tag: '烧脑神作',
  },
  {
    title: '情侣必看：浪漫电影之夜',
    desc: '精选适合二人世界的温暖电影，从经典爱情片到治愈系动画，让每一次观影都成为美好回忆。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20cinema%20date%20night%20atmosphere%20with%20warm%20candlelight%20glow%2C%20soft%20bokeh%20lights%2C%20cozy%20movie%20watching%20aesthetic%2C%20golden%20and%20coral%20warm%20tones%2C%20intimate%20cinematic%20composition&width=600&height=400&seq=cards-06&orientation=landscape',
    tag: '情侣专场',
  },
  {
    title: '进阶影迷：电影大师课',
    desc: '从希区柯克到诺兰，从黑泽明到是枝裕和。这份片单带你走进电影大师的创作世界，提升观影品味。',
    img: 'https://readdy.ai/api/search-image?query=Film%20director%20masterclass%20aesthetic%20with%20vintage%20camera%20and%20film%20equipment%2C%20warm%20studio%20lighting%2C%20classic%20cinema%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20professional%20film%20making%20composition%2C%20dark%20elegant%20background&width=600&height=400&seq=cards-07&orientation=landscape',
    tag: '大师课堂',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            精选片单
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            主题观影指南
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            不同场景、不同心情，总有一份片单适合当下的你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}